module.exports = {
  Colors: require('./colors/Colors.js')
};